@if (!isAdminScheduler()) {
	<div class="calendar-header">
		<md-header>Select Preferred Lesson Time</md-header>
		<button md-button class="clear-button" (click)="clearSelection()">Clear all</button>
	</div>

	@if (lessonsFrequency() === 1) {
		<lb-announcement-banner type="info">
			Set the preferred lesson time. You must pick <b>1</b> hour on any <b>1</b> day. This preferred time will be prioritized for instructor matching.
			<br /><br />
			Select the lesson time by clicking on the calendar below.
		</lb-announcement-banner>
	} @else {
		<lb-announcement-banner type="info">
			Set the preferred lesson times. You must pick <b>{{ lessonsFrequency() }}</b> hours on <b>{{ lessonsFrequency() }}</b> different days. This
			preferred time will be prioritized for instructor matching. <br /><br />
			Select the time for lessons by clicking and dragging on the calendar below.
		</lb-announcement-banner>
	}
}

<!-- Include the selected times here -->
<lb-schedule-base-calendar
	[class.selected]="selectedSchedules().length > 0"
	[formStep]="formStep"
	[selectedSchedules]="selectedSchedules()"
	[disableCalendar]="disableCalendar()"
	(removeScheduleSelection)="removeScheduleSelection($event)"
	(addScheduleSelection)="addScheduleSelection($event)"
>
</lb-schedule-base-calendar>
